"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var one_router_metro_exports = {};
__export(one_router_metro_exports, {
  default: () => one_router_metro_default
});
module.exports = __toCommonJS(one_router_metro_exports);
var t = __toESM(require("@babel/types"), 1);
function oneRouterMetroPlugin(_, options) {
  function isFirstInAssign(path) {
    return t.isAssignmentExpression(path.parent) && path.parent.left === path.node;
  }
  var { ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY, ONE_ROUTER_LINKING_CONFIG, ONE_ROUTER_ROOT_FOLDER_NAME, ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING, ONE_SETUP_FILE_NATIVE } = options;
  if (!ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY`);
  }
  if (!ONE_ROUTER_ROOT_FOLDER_NAME) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_ROOT_FOLDER_NAME`);
  }
  if (!ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING) {
    throw new Error(`[one/babel-plugin-one-router-metro] Must provide option: ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING`);
  }
  return {
    name: "one-router-metro",
    visitor: {
      Program(path, state) {
        var _state_filename;
        if (ONE_SETUP_FILE_NATIVE && ((_state_filename = state.filename) === null || _state_filename === void 0 ? void 0 : _state_filename.endsWith("metro-entry.js"))) {
          var importDeclaration = t.importDeclaration([], t.stringLiteral(ONE_SETUP_FILE_NATIVE));
          var body = path.get("body");
          var lastImportIndex = -1;
          for (var i = 0; i < body.length; i++) {
            if (body[i].isImportDeclaration()) {
              lastImportIndex = i;
            }
          }
          if (lastImportIndex >= 0) {
            body[lastImportIndex].insertAfter(importDeclaration);
          } else {
            path.unshiftContainer("body", importDeclaration);
          }
        }
      },
      MemberExpression(path, state) {
        if (path.get("object").matchesPattern("process.env")) {
          var key = path.toComputedKey();
          if (t.isStringLiteral(key) && !isFirstInAssign(path)) {
            if (key.value.startsWith("ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY")) {
              path.replaceWith(t.stringLiteral(ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY));
            } else if (key.value.startsWith("ONE_ROUTER_ROOT_FOLDER_NAME")) {
              path.replaceWith(t.stringLiteral(ONE_ROUTER_ROOT_FOLDER_NAME));
            } else if (key.value === "ONE_ROUTER_LINKING_CONFIG") {
              var _state_filename;
              if ((_state_filename = state.filename) === null || _state_filename === void 0 ? void 0 : _state_filename.endsWith("metro-entry.js")) {
                path.replaceWith(t.valueToNode(ONE_ROUTER_LINKING_CONFIG));
              }
            } else if (key.value.startsWith("ONE_ROUTER_REQUIRE_CONTEXT_REGEX")) {
              path.replaceWith(t.regExpLiteral(ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING));
            } else if (key.value === "ONE_SETUP_FILE_NATIVE") {
              path.replaceWith(ONE_SETUP_FILE_NATIVE ? t.stringLiteral(ONE_SETUP_FILE_NATIVE) : t.identifier("undefined"));
            }
          }
        }
      }
    }
  };
}
var one_router_metro_default = oneRouterMetroPlugin;
//# sourceMappingURL=one-router-metro.js.map
